import { TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ChromePicker } from 'react-color';
import { useBooleanStateAgg } from '../../mg/useStateAgg';
import { _IEditProps } from './_IEditProps';

//For opacity, see https://stackoverflow.com/a/60980408/581205.
export const _ColorEdit = observer(function _ColorEdit(props: _IEditProps) {
	const {accessors, type, label, error, isRequired, isReadonly, className, variant, helperText, placeholder} = props;
	const value = accessors.getter() as string;
	const openAgg = useBooleanStateAgg();
	return <>
		<TextField
			className={className}
			label={label}
			value={value}
			onClick={openAgg.trueHandler}
			error={error}
			InputProps={{style: {color: value || '#000'}}}
		/>
		{!openAgg.value ? null :
			<div style={{ position: 'relative' }}>
				<div style={{ position: 'absolute', zIndex: 2 }}>
					<div
						style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }}
						onClick={openAgg.falseHandler}
					/>
					<ChromePicker disableAlpha color={value} onChange={o => accessors.setter(o.hex)}/>
				</div>
			</div>}
	</>;
});
